import React from 'react';
import { ScreenHeader } from 'App/Header';
import styles from './Layout.module.css';

export class Layout extends React.Component {
    render() {
        return (
            <div className={styles.content_area}>
                <ScreenHeader />
                <div className={styles.body_content}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
